module.exports = __webpack_public_path__ + "static/media/skill-express.7fda2575.png";